import styled from 'styled-components';

export const Card = styled.div`
    @media (min-width: 1800px) {
        width: 13%;
    }
    @media (max-width: 800px) {
        width: 80%;
    }
    width: 50%;
`;

export const CardHeader = styled.div`
    border: 1px solid white;
    color: white;
    font-weight: bold;
    font-size: 14px;
    @media (min-width: 1400px) {
        font-size: 16px
    }
    padding: 12px;
    border-radius: 4px;
    box-sizing: border-box;
`;

export const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    @media (min-width: 1800px) {
        flex-direction: row;
    }
    flex-direction: column;
    align-items: center;
`;

export const HourRow = styled.div`
    display: flex;
    padding: 6px;
    margin-top: 6px;
    box-sizing: border-box;
    border: 1px solid white;
    border-radius: 4px;
    justify-content: space-between;
    align-items: center;
    height: 50px;
`;

export const Button = styled.button`
    background-color: white;
    color: black;
    border: 1px solid black;
    border-radius: 6px;
    font-size: 16px;
    padding-top: 6px;
    padding-bottom: 6px;
    box-sizing: border-box;
    cursor: pointer;
    margin-top: 4px;
    transition: all .2s ease-in-out;
    :hover {
        color: white;
        background-color: black;
    }
`;

export const Hour = styled.span`
    font-size: 16px;
    color: white;
`;
